/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class GroupSelector extends Component {
  @service
  strings;

  // selectedGroup is used internally to track which group is currently selected.
  @tracked
  selectedGroup = null;

  @action
  setSelectedGroup(value) {
    this.selectedGroup = value;
  }

  // selectGroup should be overridden by an action passed to this component.
  selectGroup() {}

  @action
  handleSelectGroup(group) {
    this.selectGroup(group);
    this.selectedGroup = null;
  }
}
